var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 8,
    viewBox: "0 0 31 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.759 4.15929C22.759 6.2052 24.4329 7.87912 26.4788 7.87912C28.5247 7.87912 30.1986 6.2052 30.1986 4.15929C30.1986 2.11338 28.5247 0.439454 26.4788 0.439454C24.4329 0.439454 22.759 2.11338 22.759 4.15929ZM19.0391 4.15929C19.0391 2.11338 17.3652 0.439454 15.3193 0.439454C13.2734 0.439454 11.5995 2.11338 11.5995 4.15929C11.5995 6.2052 13.2734 7.87912 15.3193 7.87912C17.3652 7.87912 19.0391 6.2052 19.0391 4.15929ZM7.87961 4.1593C7.87961 2.11339 6.20568 0.439467 4.15978 0.439467C2.11387 0.439467 0.439941 2.11339 0.439941 4.1593C0.439941 6.20521 2.11387 7.87913 4.15977 7.87913C6.20568 7.87913 7.87961 6.20521 7.87961 4.1593Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisIcon);
export default __webpack_public_path__ + "static/media/ellipsis-icon.f3197ed317d6d8a0c9e3d4336f4d222b.svg";
export { ForwardRef as ReactComponent };